import { ref } from 'vue';
import router from '@/router';
import { propertyBaseRouter, propertySubRouter } from '@/router/data';
import { pmCommonApi } from '@/api';

type PendingAllowAction = null | (() => void);
const facialPopupType = 'facial';

function openTermsOfService() {
    const route = router.resolve({
        path: `/${propertyBaseRouter}/${propertySubRouter.termsOfService}`
    });
    window.open(route.href, '_blank');
}

function openPrivacyPolicy() {
    const route = router.resolve({
        path: `/${propertyBaseRouter}/${propertySubRouter.privacyPolicy}`
    });
    window.open(route.href, '_blank');
}

function useFaceRecognitionEnrollment() {
    const isShowFaceRecognitionEnrollmentDialog = ref(false);
    const pendingAllowAction = ref<PendingAllowAction>(null);

    const openFaceRecognitionEnrollment = (action: () => void) => {
        pendingAllowAction.value = action;
        pmCommonApi.getPopupDoNotShowStatus({ popupType: facialPopupType }, ({ isShow }) => {
            if (isShow) {
                isShowFaceRecognitionEnrollmentDialog.value = true;
                return;
            }
            pendingAllowAction.value = null;
            action();
        });
    };

    const cancelFaceRecognitionEnrollment = () => {
        pendingAllowAction.value = null;
        isShowFaceRecognitionEnrollmentDialog.value = false;
    };

    const allowFaceRecognitionEnrollment = (doNotShowAgain = false) => {
        const action = pendingAllowAction.value;
        pendingAllowAction.value = null;
        isShowFaceRecognitionEnrollmentDialog.value = false;
        if (doNotShowAgain) {
            pmCommonApi.updatePopupDoNotShowStatus({ popupType: facialPopupType }, () => {
                action?.();
            });
            return;
        }
        action?.();
    };

    return {
        isShowFaceRecognitionEnrollmentDialog,
        openFaceRecognitionEnrollment,
        cancelFaceRecognitionEnrollment,
        allowFaceRecognitionEnrollment
    };
}

export {
    openTermsOfService,
    openPrivacyPolicy
};
export default useFaceRecognitionEnrollment;
